import { render, staticRenderFns } from "./main-header-navbar.vue?vue&type=template&id=043e22f4&"
import script from "./main-header-navbar.ts?vue&type=script&lang=ts&"
export * from "./main-header-navbar.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports